import isEqual from 'lodash/isEqual';

export default isEqual;
